import dataFetcher, { keyedDataFetcher } from "modules/dataFetcher";
import api from "services/api";
import ModalService from "services/modal";
import store from "services/store";

export const modalService = new ModalService();

export const auditSysMsgFetcher = dataFetcher({
  selectors: ["audit-user-message", (state) => state.audit.auditUid],
  async fetchData([_, auditUid]) {
    const res = await api.get(`v1/audits/${auditUid}/sysMsg`);
    return res.actionMsg;
  },
});

export const auditFetcher = dataFetcher({
  selectors: ["audit-details", () => modalService.data?.auditUid],
  async fetchData([_, auditUid]) {
    return api.get(`v1/audits/${auditUid}`);
  },
});

const RESOURCE_NAMES_URLS = {
  spectrocluster: "v1/dashboard/spectroclusters/search",
  clusterprofile: "v1/dashboard/clusterprofiles",
  location: "v1/users/assets/locations",
  sshkey: "v1/users/assets/sshkeys",
  workspace: "v1/dashboard/workspaces",
  cloudaccount: "v1/cloudaccounts/summary",
  clustergroup: "v1/clustergroups/hostCluster",
  virtualCluster: "v1/dashboard/spectroclusters/search",
  spcpolicy: "v1/dashboard/spcPolicies",
  clustertemplate: "v1/dashboard/clusterTemplates",
};

const getClusterFilters = ({ isVirtualCluster = false }) => {
  return {
    filter: {
      conjunction: "and",
      filterGroups: [
        {
          conjunction: "and",
          filters: [
            {
              property: "clusterState",
              type: "string",
              condition: {
                string: {
                  operator: "eq",
                  negation: false,
                  match: {
                    conjunction: "or",
                    values: [
                      "Pending",
                      "Provisioning",
                      "Running",
                      "Deleting",
                      "Importing",
                      "Unknown",
                      "Deleted",
                    ],
                  },
                  ignoreCase: false,
                },
              },
            },
            isVirtualCluster && {
              property: "environment",
              type: "string",
              condition: {
                string: {
                  operator: "eq",
                  negation: false,
                  match: {
                    conjunction: "or",
                    values: ["nested"],
                  },
                  ignoreCase: false,
                },
              },
            },
          ].filter(Boolean),
        },
      ],
    },
  };
};

export const resourceNamesFetcher = keyedDataFetcher({
  selectors: ["resource-names"],
  async fetchData([_1, resourceKind], { projectId }) {
    const state = store.getState();
    const currentResponse =
      resourceNamesFetcher.key(resourceKind).selector(state)?.result || {};
    const token = currentResponse.listmeta?.continue || "";
    const params = new URLSearchParams(
      [
        "clusterprofile",
        "virtualCluster",
        "cloudaccount",
        "spectrocluster",
        "spcpolicy",
        "clustertemplate",
      ].includes(resourceKind)
        ? { limit: 50, ...(token && { continue: token }) }
        : {}
    );
    const urlPath = `${RESOURCE_NAMES_URLS[resourceKind]}?${params}`;
    const headers = { ProjectUid: projectId };

    let nextResponse = null;
    if (
      [
        "virtualCluster",
        "spectrocluster",
        "spcpolicy",
        "clustertemplate",
      ].includes(resourceKind)
    ) {
      nextResponse = await api.post(
        urlPath,
        getClusterFilters({
          isVirtualCluster: resourceKind === "virtualCluster",
        }),
        {
          headers,
        }
      );
    } else if (resourceKind === "clusterprofile") {
      nextResponse = await api.post(
        urlPath,
        {},
        {
          headers,
        }
      );
    } else {
      nextResponse = await api.get(urlPath, null, {
        headers,
      });
    }

    return {
      items: (currentResponse?.items || []).concat(
        nextResponse?.items || nextResponse?.summaries || nextResponse || []
      ),
      listmeta: nextResponse.listmeta || {},
    };
  },
});
